/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect, useMemo } from "react";
import Accordion from "react-bootstrap/Accordion";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import ReactPaginate from "react-paginate";
import Typewriter from "typewriter-effect";

const authUrl = process.env.REACT_APP_API_ENDPOINT_AUTH;
const jobsUrl = process.env.REACT_APP_API_ENDPOINT_JOBS;
const clientId = process.env.REACT_APP_API_CLIENT_ID;
const secret = process.env.REACT_APP_API_SECRET;

function App() {
  const [showLoader, setShowLoader] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [jobPositionCity, setJobPositionCity] = useState([]);
  const [selectedCityId, setSelectedCityId] = useState("");
  const [jobPositionTitle, setJobPositionTitle] = useState([]);
  const [selectedTitleId, setSelectedTitleId] = useState("");

  // tratamento e paginação das vagas
  const [itemOffsetEffectiveJobs, setItemOffsetEffectiveJobs] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 3;
  const endOffsetEffectiveJobs = itemOffsetEffectiveJobs + itemsPerPage;

  const filteredJobs = useMemo(() => {
    return jobs.filter((job) => {
      const matchesCity =
        !selectedCityId || job.cityId === Number(selectedCityId);

      const matchesTitle =
        !selectedTitleId || job.titlePositionId === Number(selectedTitleId);

      return matchesCity && matchesTitle;
    });
  }, [jobs, selectedCityId, selectedTitleId]);

  const currentEffectiveJobs = filteredJobs.slice(
    itemOffsetEffectiveJobs,
    endOffsetEffectiveJobs,
  );

  const pageCountEffectiveJobs = Math.ceil(filteredJobs.length / itemsPerPage);

  const handlePageClickEffectiveJobs = (event) => {
    const newOffset = (event.selected * itemsPerPage) % filteredJobs.length;
    setItemOffsetEffectiveJobs(newOffset);
    setCurrentPage(event.selected);
  };

  // ----------------------------

  // burguer menu
  const toggleBurguerMenu = () => {
    const burguerMenu = document.querySelector(".burguer-menu");
    const burguerContent = document.querySelector(".burguer-content");

    burguerMenu.onclick = function () {
      burguerContent.classList.toggle("show-menu");
    };

    burguerContent.onclick = function () {
      burguerContent.classList.remove("show-menu");
    };

    document.onclick = function (e) {
      if (
        !burguerMenu.contains(e.target) &&
        !burguerContent.contains(e.target)
      ) {
        burguerContent.classList.remove("show-menu");
      }
    };
  };

  // -----------------------------

  const onChangeFilterJobs = ($event) => {
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    setSelectedCityId($event.target.value);
  };

  const onChangeFilterJobsTitle = ($event) => {
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    setSelectedTitleId($event.target.value);
  };

  const generateNonce = () => {
    const nonce = Math.floor(Math.random() * 1000000000);
    return nonce;
  };

  const generateTimestamp = () => {
    const timestamp = Math.floor(Date.now() / 1000).toString();
    return timestamp;
  };

  useEffect(() => {
    toggleBurguerMenu();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoader(true);

      let retries = 0;
      let success = false;

      while (retries <= 2 && !success) {
        try {
          let token = localStorage.getItem("api_token");
          let storedNonce =
            localStorage.getItem("api_nonce") || generateNonce();
          let storedTimestamp =
            localStorage.getItem("api_timestamp") || generateTimestamp();

          if (!token) {
            const authResponse = await fetch(`${authUrl}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Nonce": storedNonce,
                "X-Timestamp": storedTimestamp,
              },
              body: JSON.stringify({
                clientId: clientId,
                secret: secret,
              }),
            });

            if (!authResponse.ok) throw new Error("Erro na autenticação");

            const authData = await authResponse.json();
            token = authData.token;

            localStorage.setItem("api_token", token);
            localStorage.setItem("api_nonce", storedNonce);
            localStorage.setItem("api_timestamp", storedTimestamp);
          }

          const dataResponse = await fetch(`${jobsUrl}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              "X-Target": "blackfriday",
              "X-Nonce": storedNonce,
              "X-Timestamp": storedTimestamp,
            },
          });

          if (dataResponse.status === 401) {
            localStorage.clear();

            retries++;
            continue;
          }

          if (!dataResponse.ok) throw new Error("Erro ao buscar dados");

          const jobsData = await dataResponse.json();

          setJobs(jobsData.jobPositionList);
          setJobPositionCity(jobsData.cityList);
          setJobPositionTitle(jobsData.titlePositionList);

          success = true;
        } catch (error) {
          console.error("Erro no fluxo:", error);
          retries++;
        }
      }

      setShowLoader(false);
    };

    fetchData();
  }, []);

  return (
    <div className="w-full h-auto">
      <nav className="h-25 w-full">
        <div className="w-full flex items-center justify-center gap-[17%] !p-4 max-[1024px]:justify-between">
          <div>
            <img
              src="./assets/icons/randstad-logo.svg"
              alt="RandStad Landing Page Logo"
              className="h-26 max-[1024px]:h-10"
            />
          </div>

          <div className="burguer-menu cursor-pointer mb-1">
            <img
              src="./assets/icons/Menu.svg"
              alt="menu"
              className="rounded-none w-full h-full"
            />
          </div>

          <ul
            id="content-burger-menu"
            className="flex flex-row justify-end items-center gap-6 mb-0 text-[#2175D9] max-[1024px]:hidden burguer-content"
          >
            <li>
              <a
                href="#oportunidades"
                className="hover:border-b-2 hover:border-white"
              >
                veja as vagas
              </a>
            </li>
            <li>
              <a
                href="#setores"
                className="hover:border-b-2 hover:border-white"
              >
                principais setores
              </a>
            </li>
            <li>
              <a
                href="#comoFunciona"
                className="hover:border-b-2 hover:border-white"
              >
                como funciona
              </a>
            </li>
            <li>
              <a
                href="https://www.randstad.com.br/contate-nos/contato-candidato/"
                target="_blank"
                className="hover:border-b-2 hover:border-white"
                rel="noreferrer"
              >
                contato
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div className="flex w-full h-[800px] background max-[1024px]:flex-col max-[1024px]:h-auto max-[1024px]:mt-14 min-[2560px]:h-[40vw]">
        <div className="flex justify-center items-center mb-[10vw] w-[60%] max-[1024px]:w-full max-[1024px]:px-[7vw]">
          <div className="w-[57%] max-[1024px]:w-full">
            <h1 className="text-[72px] text-[#2175D9] max-[1024px]:text-4xl">
              vagas temporárias de fim de ano!
            </h1>
            <h2 className="text-[#968C8C] my-3 max-[1024px]:text-justify">
              Descubra as melhores vagas temporárias de fim de ano com a
              Randstad. Trabalhe nos maiores empregadores do Brasil, desenvolva
              sua carreira e aumente sua renda.
            </h2>
            <div className="h-[100px]">
              <div className="flex items-center font-bold shadow-box px-4 py-3 rounded-md">
                <img
                  src="./assets/icons/search.svg"
                  alt="Search icon"
                  className="mr-2"
                />
                <p className="text-[#3D2F4B] mr-1">Encontre vagas no setor</p>
                <Typewriter
                  options={{
                    strings: ["industrial, varejo, moda..."],
                    autoStart: true,
                    loop: true,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="w-[40%] flex justify-center items-center relative max-lg:w-full max-lg:px-[9vw] max-lg:pb-[10vw]">
          <div>
            <img
              src="./assets/images/image-profile.png"
              alt="Profile"
              className="w-[34vw] h-[34vw] max-w-[700px] max-h-[700px] rounded-[50%] object-cover max-lg:w-[80vw] max-lg:h-[80vw]"
            />
            <a
              href="#oportunidades"
              className="bg-white px-4 py-2 rounded-full button-profile max-[1024px]:hidden"
            >
              Confira as melhores vagas na Randstad!
            </a>
          </div>
        </div>
      </div>

      <div
        className="flex justify-center items-center gap-[4%] bg-[#2175D9] -mt-1 pb-5 border-b-[20px] border-solid border-[#0F1941]
      max-[1024px]:flex-col-reverse max-[1024px]:px-[7vw]"
      >
        <img
          src="./assets/images/image-1.png"
          alt="Randstad"
          className="w-[28vw] h-[28vw] max-w-[550px] max-h-[550px] rounded-[50%] object-cover max-lg:w-[80vw] max-lg:h-[80vw]"
        />
        <div className="flex flex-col w-[40%] max-[1024px]:w-full max-[1024px]:mt-8">
          <h1 className="text-white text-[48px] max-[1024px]:text-4xl">
            vagas temporárias de fim de ano: encontre a sua com a randstad
          </h1>
          <p className="text-white w-[90%] my-2 max-[1024px]:text-justify max-[1024px]:w-full">
            Em 2024, conectamos mais de 4.000 profissionais a vagas temporárias
            para a Black Friday e festas de fim de ano, e a expectativa para
            2025 é ainda maior. Essa pode ser a sua chance de ganhar
            experiência, renda extra e abrir portas para o futuro.
          </p>
          <a
            href="#oportunidades"
            className="w-[280px] mt-1 text-white text-center text-lg px-4 py-3 rounded-md border border-solid
            max-[1024px]:hidden"
          >
            veja as vagas disponíveis
          </a>
        </div>
      </div>

      <div
        className="w-full flex flex-col justify-center py-20 px-[7vw]"
        id="oportunidades"
      >
        <h1 className="text-6xl text-blue-500 mb-4 max-[1024px]:text-4xl w-[50%] max-[1024px]:w-full">
          trabalhe nos melhores empregadores do país!
        </h1>

        <div className="bg-[#2175D9] !px-[10%] rounded-[30px] py-5">
          <div className="flex justify-between max-[1024px]:flex-col">
            <select
              value={selectedTitleId}
              onChange={onChangeFilterJobsTitle}
              className="filter-btn w-[350px] mb-4 p-2 cursor-pointer max-[768px]:w-full"
            >
              <option value="">Todas os cargos</option>
              {jobPositionTitle.map((jobId, i) => (
                <option value={jobId.id} key={i}>
                  {jobId.name}
                </option>
              ))}
            </select>
            <select
              value={selectedCityId}
              onChange={onChangeFilterJobs}
              className="filter-btn w-[350px] mb-4 p-2 cursor-pointer max-[768px]:w-full"
            >
              <option value="">Todas as cidades</option>
              {jobPositionCity.map((jobId, i) => (
                <option value={jobId.id} key={i}>
                  {jobId.name} {jobId.stateCode ? `- ${jobId.stateCode}` : ""}
                </option>
              ))}
            </select>
          </div>
          {showLoader && (
            <div className="w-full flex flex-col items-center mt-20 max-[768px]:w-full">
              <Spinner animation="grow" />
              <h4 className="text-[#fff] mt-4">Carregando</h4>
            </div>
          )}
          {!showLoader && currentEffectiveJobs.length ? (
            <>
              <ul>
                {currentEffectiveJobs.map((job, i) => (
                  <li className="jobs-list" key={i}>
                    <div className="w-[70%] pl-3 max-[768px]:w-full max-[768px]:p-0">
                      <p className="!m-0 max-[768px]:text-center">{job.name}</p>
                    </div>
                    <div className="w-[30%] flex justify-end max-[768px]:w-full max-[768px]:justify-center">
                      <Button
                        className="py-2 bg-[#2175D9] px-5 cursor-pointer self-end rounded-full"
                        variant="primary"
                        href={job.shortUrl}
                        target="_blank"
                      >
                        candidatar-se
                      </Button>
                    </div>
                  </li>
                ))}
              </ul>

              <ReactPaginate
                containerClassName="pagination"
                breakLabel="..."
                nextLabel="Próximo >"
                onPageChange={handlePageClickEffectiveJobs}
                marginPagesDisplayed={2}
                pageCount={pageCountEffectiveJobs}
                forcePage={currentPage}
                previousLabel="< Anterior"
                renderOnZeroPageCount={null}
              />
            </>
          ) : null}
          {!showLoader && !currentEffectiveJobs.length ? (
            <div className="jobs-list !justify-center">
              <h2 className="text-xl text-center">
                Não encontramos resultados para sua busca.
              </h2>
            </div>
          ) : null}
        </div>
      </div>

      <div className="flex flex-col bg-[#0F1941] max-[1024px]:px-[7vw]">
        <div className="flex flex-col text-white text-center">
          <h1 className="text-[40px] my-4 max-[1024px]:text-4xl">
            por que vale a pena buscar uma vaga temporária para o fim de ano?
          </h1>
          <p>
            Antes de garantir sua vaga, confira por que o trabalho temporário no
            fim do ano é uma excelente escolha para sua carreira:
          </p>
        </div>
        <div className="flex flex-wrap justify-evenly my-5 max-[1024px]:flex-col max-[1024px]:gap-4">
          <div className="flex flex-col w-[22%] bg-white rounded-2xl gap-3 p-5 max-[1024px]:w-full">
            <img
              src="./assets/icons/person.svg"
              alt="Randstad icons"
              className="w-[86px] h-[86px]"
            />
            <h3 className="text-2xl">alta demanda por mão de obra</h3>
            <p className="text-[#968C8C]">
              O fim do ano gera milhares de vagas temporárias em SP e em todo o
              Brasil, para diferentes perfis e turnos.
            </p>
          </div>
          <div className="flex flex-col w-[22%] bg-white rounded-2xl gap-3 p-5 max-[1024px]:w-full">
            <img
              src="./assets/icons/star.svg"
              alt="Randstad icons"
              className="w-[86px] h-[86px]"
            />
            <h3 className="text-2xl">
              oportunidade de conquistar experiência profissional
            </h3>
            <p className="text-[#968C8C]">
              Vivencie um ambiente dinâmico e enriqueça seu currículo com
              trabalhos temporários em grandes empresas.
            </p>
          </div>
          <div className="flex flex-col w-[22%] bg-white rounded-2xl gap-3 p-5 max-[1024px]:w-full">
            <img
              src="./assets/icons/hand.svg"
              alt="Randstad icons"
              className="w-[78px] h-[76px] mt-[6px]"
            />
            <h3 className="text-2xl">renda extra para fechar o ano no azul</h3>
            <p className="text-[#968C8C]">
              A Black Friday e as festividades de final de ano são o momento
              ideal para complementar a renda com um trabalho temporário.
            </p>
          </div>
          <div className="flex flex-col w-[22%] bg-white rounded-2xl gap-3 p-5 max-[1024px]:w-full">
            <img
              src="./assets/icons/heart.svg"
              alt="Randstad icons"
              className="w-[86px] h-[86px]"
            />
            <h3 className="text-2xl">
              oportunidade de concorrer para vagas efetivas
            </h3>
            <p className="text-[#968C8C]">
              Muitos contratos de vaga temporária de final de ano podem se
              transformar em oportunidades permanentes de emprego.
            </p>
          </div>
        </div>
      </div>

      <div
        id="setores"
        className="flex flex-col justify-center py-5 px-1 max-[1024px]:!px-[7vw]"
      >
        <div className="flex flex-col justify-center items-center text-center mb-14">
          <h1 className="text-[40px] text-[#2175D9] w-[60%] max-[1024px]:w-full">
            quais são os principais setores com vagas abertas ?
          </h1>
          <p className="text-[#656C85] mt-2 w-[60%] max-[1024px]:w-full">
            No fim do ano, a alta demanda abre milhares de vagas temporárias,
            especialmente em setores que ganham força na Black Friday e nas
            festas. Confira as áreas que mais contratam e escolha sua vaga
            temporária final de ano com a Randstad:
          </p>
        </div>
        <div className="flex justify-center gap-3 max-[1024px]:flex-col">
          <div className="content-slide">
            <div className="rectangle">
              <h3>varejo físico e online</h3>
            </div>
            <div className="flex w-full items-end gap-[2%] max-[1024px]:flex-col">
              <h2 className="text-4xl font-semibold">varejo físico e online</h2>
              <p className="pl-[15%] opacity-80 max-[1024px]:pl-0 max-[1024px]:mt-3">
                lojas, shoppings e e-commerces com vagas imediatas para
                vendedor, operador de caixa, estoquista e repositor
              </p>
            </div>
          </div>
          <div className="content-slide box-2">
            <div className="rectangle">
              <h3>logística e centros de distribuição</h3>
            </div>
            <div className="flex w-full items-end gap-[2%] max-[1024px]:flex-col">
              <h2 className="text-4xl font-semibold">
                Logística e centros de distribuição
              </h2>
              <p className="pl-[15%] opacity-80 max-[1024px]:pl-0 max-[1024px]:mt-3">
                preparo e entrega de pedidos com oportunidades para auxiliar de
                logística e conferente — destaque para as vagas temporárias em
                SP;
              </p>
            </div>
          </div>
          <div className="content-slide box-3">
            <div className="rectangle">
              <h3>supermercados e atacados</h3>
            </div>
            <div className="flex w-full items-end gap-[2%] max-[1024px]:flex-col">
              <h2 className="text-4xl font-semibold max-[1024px]:w-full">
                Supermercados e atacarejos
              </h2>
              <p className="pl-[15%] opacity-80 max-[1024px]:pl-0 max-[1024px]:mt-3">
                funções operacionais em reposição de mercadorias, empacotamento
                e atendimento;
              </p>
            </div>
          </div>
          <div className="content-slide box-4">
            <div className="rectangle">
              <h3>eventos e promoções</h3>
            </div>
            <div className="flex w-full items-end gap-[2%] max-[1024px]:flex-col">
              <h2 className="text-4xl font-semibold">Eventos e promoções</h2>
              <p className="pl-[15%] opacity-80 max-[1024px]:pl-0 max-[1024px]:mt-3">
                ações promocionais, degustações e ativações de marca em pontos
                de venda;
              </p>
            </div>
          </div>
          <div className="content-slide box-5">
            <div className="rectangle">
              <h3>transportes e entregas</h3>
            </div>
            <div className="flex w-full items-end gap-[2%] max-[1024px]:flex-col">
              <h2 className="text-4xl font-semibold">Transporte e entregas</h2>
              <p className="pl-[15%] opacity-80 max-[1024px]:pl-0 max-[1024px]:mt-3">
                motoristas, ajudantes e operadores em rotas urbanas para
                suportar o aumento de pedidos;
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center items-center gap-[5%] bg-[#2175D9] py-14 max-[1024px]:flex-col max-[1024px]:px-[7vw]">
        <div className="flex flex-col w-[40%] gap-3 max-[1024px]:w-full">
          <h2 className="text-[36px] text-white max-[1024px]:text-4xl">
            não perca tempo: candidate-se agora!
          </h2>
          <p className="text-[22px] text-white">
            Mais de 4.000 pessoas já garantiram suas vagas imediatas com a
            Randstad no último ano. Chegou a sua vez!
          </p>
          <a
            href="#oportunidades2"
            className="w-[280px] mt-1 text-white text-center text-lg px-4 py-3 rounded-md border border-solid max-[1024px]:hidden"
          >
            veja as vagas disponíveis
          </a>
        </div>
        <div>
          <img src="./assets/images/image-2.png" alt="Randstad" className="" />
        </div>
      </div>

      <div className="flex justify-center items-center gap-[10%] py-16 max-[1024px]:flex-col max-[1024px]:px-[7vw]">
        <div className="w-[40%] max-[1024px]:w-full max-[1024px]:mb-10">
          <img
            src="./assets/images/image-3.png"
            alt="Randstad"
            className="w-full"
          />
        </div>
        <div className="w-[25%] max-[1024px]:w-full">
          <h1 className="text-[40px] text-[#2175D9] mb-1 max-[1024px]:text-4xl">
            essa vaga é para você?
          </h1>
          <h2 className="text-[20px] text-[#161C2D] mb-4">
            veja os requisitos aqui
          </h2>
          <div className="flex flex-col gap-4">
            <div className="flex gap-3">
              <img src="./assets/icons/1.svg" alt="Randstad" className="" />
              <div className="flex flex-col !mt-6">
                <h2 className="text-[24px] text-[#2175D9]">Escolaridade</h2>
                <p className="text-[#161C2D]">
                  ensino médio completo ou fundamental
                </p>
              </div>
            </div>
            <div className="flex gap-3">
              <img src="./assets/icons/2.svg" alt="Randstad" className="" />
              <div className="flex flex-col !mt-6">
                <h2 className="text-[24px] text-[#2175D9]">Habilidades</h2>
                <p className="text-[#161C2D]">
                  proatividade, boa comunicação, organização e trabalho em
                  equipe
                </p>
              </div>
            </div>
            <div className="flex gap-3">
              <img src="./assets/icons/3.svg" alt="Randstad" className="" />
              <div className="flex flex-col !mt-6">
                <h2 className="text-[24px] text-[#2175D9]">Disponibilidade</h2>
                <p className="text-[#161C2D]">
                  turnos flexíveis, incluindo finais de semana e feriados.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="comoFunciona"
        className="flex justify-center items-center gap-[2%] py-8 max-[1024px]:flex-col-reverse max-[1024px]:px-[7vw]"
      >
        <div className="w-[35%] max-[1024px]:w-full">
          <h1 className="text-[40px] text-[#2175D9] mb-3 max-[1024px]:text-4xl">
            como funciona o processo seletivo para as vagas temporárias?
          </h1>
          <p className="text-[#161C2D] mb-4">
            O processo é simples: inscreva-se no portal, envie seu currículo e
            aguarde o contato do nosso consultor.
          </p>
          <p className="text-[#161C2D] mb-4">
            Todas as vagas temporárias incluem treinamento para que você chegue
            preparado(a).
          </p>
        </div>
        <div className="w-[40%] max-[1024px]:w-full">
          <img
            src="./assets/images/image-4.png"
            alt="Randstad"
            className="w-full"
          />
        </div>
      </div>

      <div className="flex justify-center items-center gap-[5%] bg-[#2175D9] max-[1024px]:flex-col max-[1024px]:px-[7vw] max-[1024px]:pt-10">
        <div className="flex flex-col w-[40%] gap-3 max-[1024px]:w-full">
          <h2 className="text-[36px] text-white">
            quer aproveitar as oportunidades de fim de ano?
          </h2>
          <p className="text-[22px] text-white">
            Seja para ganhar experiência, renda extra ou até conquistar uma
            efetivação, fica fácil encontrar a vaga temporária de fim de ano que
            mais combina com você com tantas opções de trabalhos temporários.
          </p>
          <a
            href="#oportunidades2"
            className="w-[280px] mt-1 text-white text-center text-lg px-4 py-3 rounded-md border border-solid max-[1024px]:hidden"
          >
            veja as vagas disponíveis
          </a>
        </div>
        <div>
          <img src="./assets/images/image-5.png" alt="Randstad" className="" />
        </div>
      </div>

      <div className="flex justify-center gap-[10%] pt-20 max-[1024px]:flex-col-reverse max-[1024px]:px-[7vw]">
        <div className="mt-12">
          <img
            src="./assets/images/image-6.png"
            alt="Randstad"
            className="w-full"
          />
        </div>
        <div className="flex flex-col w-[30%] max-[1024px]:w-full ">
          <h1 className="text-[40px] text-[#2175D9] mb-4 max-[1024px]:hidden">
            confira dúvidas sobre vagas temporárias de fim de ano
          </h1>
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                qual o período de duração dos contratos temporários?
              </Accordion.Header>
              <Accordion.Body>
                Os contratos costumam acompanhar o movimento do comércio:
                começam em outubro ou novembro e seguem até dezembro. Em alguns
                casos, podem ser estendidos dependendo das necessidades da
                empresa e do seu desempenho.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                receberei treinamento antes de começar?
              </Accordion.Header>
              <Accordion.Body>
                Sim! Queremos que você se sinta preparado e confiante no
                primeiro dia. Por isso, todas as vagas incluem um treinamento
                básico para que você entenda bem as suas funções.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>
                existe a possibilidade de ser efetivado após o período
                temporário?
              </Accordion.Header>
              <Accordion.Body>
                Essa é uma das maiores vantagens do trabalho temporário: quem se
                destaca pode ser convidado a permanecer na equipe após o fim do
                contrato. Então, dê o seu melhor, pois as empresas estão de olho
                em talentos!
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>
                quais são os benefícios oferecidos?
              </Accordion.Header>
              <Accordion.Body>
                Além do salário compatível com a função, você pode contar com
                benefícios como vale- transporte e vale-refeição ou alimentação.
                Os detalhes são sempre explicados durante o processo seletivo
                para que você já saiba o que esperar.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>preciso ter experiência?</Accordion.Header>
              <Accordion.Body>
                Depende da vaga! Para funções como vendedor ou caixa, a
                experiência é um diferencial. Já para cargos como auxiliar e
                operador de loja, basta ter vontade de aprender e disposição
                para encarar o desafio.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5">
              <Accordion.Header>
                quais são os horários de trabalho?
              </Accordion.Header>
              <Accordion.Body>
                As empresas precisam de gente disponível para diferentes turnos,
                principalmente no período da tarde e noite, entre 14h e 22h. Mas
                sempre conversamos com você para encontrar a melhor combinação
                de horário possível.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="6">
              <Accordion.Header>
                como sei se fui selecionado para a vaga?
              </Accordion.Header>
              <Accordion.Body>
                Fique tranquilo: assim que a empresa aprovar seu perfil, um de
                nossos consultores entrará em contato por telefone ou WhatsApp
                para explicar os próximos passos.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>

      <div
        className="w-full flex flex-col justify-center py-20 px-[7vw]"
        id="oportunidades2"
      >
        <h1 className="text-6xl text-blue-500 mb-4 max-[1024px]:text-4xl w-[50%] max-[1024px]:w-full">
          trabalhe nos melhores empregadores do país!
        </h1>

        <div className="bg-[#2175D9] !px-[10%] rounded-[30px] py-5">
          <div className="flex justify-between max-[1024px]:flex-col">
            <select
              value={selectedTitleId}
              onChange={onChangeFilterJobsTitle}
              className="filter-btn w-[350px] mb-4 p-2 cursor-pointer max-[768px]:w-full"
            >
              <option value="">Todas os cargos</option>
              {jobPositionTitle.map((jobId, i) => (
                <option value={jobId.id} key={i}>
                  {jobId.name}
                </option>
              ))}
            </select>
            <select
              value={selectedCityId}
              onChange={onChangeFilterJobs}
              className="filter-btn w-[350px] mb-4 p-2 cursor-pointer max-[768px]:w-full"
            >
              <option value="">Todas as cidades</option>
              {jobPositionCity.map((jobId, i) => (
                <option value={jobId.id} key={i}>
                  {jobId.name} {jobId.stateCode ? `- ${jobId.stateCode}` : ""}
                </option>
              ))}
            </select>
          </div>
          {showLoader && (
            <div className="w-full flex flex-col items-center mt-20 max-[768px]:w-full">
              <Spinner animation="grow" />
              <h4 className="text-[#fff] mt-4">Carregando</h4>
            </div>
          )}
          {!showLoader && currentEffectiveJobs.length ? (
            <>
              <ul>
                {currentEffectiveJobs.map((job, i) => (
                  <li className="jobs-list" key={i}>
                    <div className="w-[70%] pl-3 max-[768px]:w-full max-[768px]:p-0">
                      <p className="!m-0 max-[768px]:text-center">{job.name}</p>
                    </div>
                    <div className="w-[30%] flex justify-end max-[768px]:w-full max-[768px]:justify-center">
                      <Button
                        className="py-2 bg-[#2175D9] px-5 cursor-pointer self-end rounded-full"
                        variant="primary"
                        href={job.shortUrl}
                        target="_blank"
                      >
                        candidatar-se
                      </Button>
                    </div>
                  </li>
                ))}
              </ul>

              <ReactPaginate
                containerClassName="pagination"
                breakLabel="..."
                nextLabel="Próximo >"
                onPageChange={handlePageClickEffectiveJobs}
                marginPagesDisplayed={2}
                pageCount={pageCountEffectiveJobs}
                forcePage={currentPage}
                previousLabel="< Anterior"
                renderOnZeroPageCount={null}
              />
            </>
          ) : null}
          {!showLoader && !currentEffectiveJobs.length ? (
            <div className="jobs-list !justify-center">
              <h2 className="text-xl text-center">
                Não encontramos resultados para sua busca.
              </h2>
            </div>
          ) : null}
        </div>
      </div>

      <div className="relative">
        <img
          src="./assets/images/image-7.png"
          alt="Randstad"
          className="w-full max-[1024px]:hidden"
        />
        <div
          className="flex flex-col w-full h-full justify-center pl-[7%] absolute top-0 left-0 z-50 max-[1024px]:relative
        max-[1024px]:px-[7vw] max-[1024px]:text-center max-[1024px]:mb-10"
        >
          <div className="flex flex-col w-fit items-center">
            <h1 className="text-[48px] text-[#2175D9] mb-4">
              ainda com dúvidas?
            </h1>
            <a
              href="https://www.randstad.com.br/contate-nos/contato-candidato/"
              target="_blank"
              rel="noreferrer"
              className="bg-[#2175D9] w-[230px] text-center py-3 px-6 rounded-[4px] text-white transition"
            >
              fale conosco
            </a>
          </div>
        </div>
      </div>

      <footer className="bg-[#2074D9] text-white pt-8 max-[1024px]:pb-8">
        <div className="container mx-auto flex flex-col items-center md:flex-row md:justify-between px-4">
          <div className="mb-4 md:mb-0">
            <img
              src="./assets/icons/randstad-white.svg"
              alt="Randstad Logo"
              className=""
            />
          </div>

          <div className="mb-4 md:mb-0">
            <p className="mb-2">
              Randstad Brasil Recursos Humanos LTDA é uma empresa registrada no
              Brasil sob CNPJ 03.573.863/000
            </p>
            <p>
              Escritório da matriz encontra-se na Av. Francisco Matarazzo, 1350,
              20º andar / CEP: 05001-100
            </p>
            <p>
              A Randstad trata dados pessoais de acordo com a LGPD (Lei
              13.709/18). Leia nosso{" "}
              <a
                href="https://www.randstad.com.br/sobre-sua-privacidade/"
                target="_blank"
                className="text-white !underline hover:!no-underline"
                rel="noreferrer"
              >
                Aviso de Privacidade
              </a>
              .
            </p>
          </div>

          <div className="flex space-x-4">
            <a
              href="https://www.linkedin.com/company/randstad-brasil/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/linkedin-logo.png" alt="Linkedin Logo" />
            </a>
            <a
              href="https://www.youtube.com/user/randstadbrasil/featured"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/youtube-logo.png" alt="Youtube Logo" />
            </a>
            <a
              href="https://www.facebook.com/RandstadBR/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/facebook-logo.png" alt="Facebook Logo" />
            </a>
            <a
              href="https://www.instagram.com/randstadbr/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img
                src="./assets/icons/instagram-logo.png"
                alt="Instagram Logo"
              />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
